import { ReactElement } from 'react'

import FindCaminhaoByPlacaImpl from 'modules/caminhao/domain/usecases/FindCaminhaoByPlaca'
import CaminhaoRepository from 'modules/caminhao/infra/repositories/CaminhaoRepository'
import CancelaViagemImpl from 'modules/lotes/domain/usecases/CancelaViagem'
import DirecionarCargasImpl from 'modules/lotes/domain/usecases/DirecionarCargas'
import FinalizaViagemImpl from 'modules/lotes/domain/usecases/FinalizaViagem'
import ValidateCaminhaoImpl from 'modules/lotes/domain/usecases/ValidateCaminhao'
import ValidateMotoristaImpl from 'modules/lotes/domain/usecases/ValidateMotorista'
import LoteRepository from 'modules/lotes/infra/repositories/LoteRepository'
import DirecionaCarga from 'modules/lotes/pages/DirecionaCarga'
import FindByCpfNomeFrotistaIdImpl from 'modules/motorista/domain/usecases/FindByCpfNomeFrotistaId'
import MotoristaRepository from 'modules/motorista/infra/repositories/MotoristaRepository'
import ValidateAnttImpl from 'modules/user/domain/usecases/ValidateAnttImpl'
import UserRepository from 'modules/user/infra/repositories/UserRepository'
import { IUserRepository } from 'modules/user/domain/repositories/IUserRepository'
import FindAllImpl from 'modules/pedagio/domain/usecases/FindAll'
import FindActiveTagImpl from 'modules/pedagio/domain/usecases/FindActiveTag'
import TagPedagioRepository from 'modules/pedagio/infra/repositories/TagPedagioRepository'
import SaveTagImpl from 'modules/pedagio/domain/usecases/SaveTag'

export const DirecionaCargaFactory = (): ReactElement => {
  const motoristaRepository = new MotoristaRepository()
  const tagPedagioRepository = new TagPedagioRepository()
  const findByNomeImpl = new FindByCpfNomeFrotistaIdImpl(motoristaRepository)
  const caminhaoRepository = new CaminhaoRepository()
  const findByPlacaImpl = new FindCaminhaoByPlacaImpl(caminhaoRepository)
  const lotesRepository = new LoteRepository()
  const userRepository: IUserRepository = new UserRepository()
  const direcionarCargasImpl = new DirecionarCargasImpl(lotesRepository)
  const validateMotoristaImpl = new ValidateMotoristaImpl(lotesRepository)
  const validateCaminhaoImpl = new ValidateCaminhaoImpl(lotesRepository)
  const finalizaViagemImpl = new FinalizaViagemImpl(lotesRepository)
  const cancelaViagemImpl = new CancelaViagemImpl(lotesRepository)
  const validateAnttImpl = new ValidateAnttImpl(userRepository)
  const findAllImpl = new FindAllImpl(tagPedagioRepository)
  const findActiveTagImpl = new FindActiveTagImpl(tagPedagioRepository)
  const saveTagImpl = new SaveTagImpl(tagPedagioRepository)

  return (
    <DirecionaCarga
      findByNome={findByNomeImpl}
      findByPlaca={findByPlacaImpl}
      direcionarCargas={direcionarCargasImpl}
      validateMotorista={validateMotoristaImpl}
      validateCaminhao={validateCaminhaoImpl}
      finalizaViagem={finalizaViagemImpl}
      cancelaViagem={cancelaViagemImpl}
      validateAntt={validateAnttImpl}
      findAll={findAllImpl}
      findActiveTag={findActiveTagImpl}
      saveTag={saveTagImpl}
    />
  )
}
